import { callBackend } from './backend';
import type { ApiResponse } from './backend';

export interface PublicBank {
  name: string;
  country: string | null;
  swift: string | null;
  initials: string;
}

export interface PublicTransfer {
  reference: string;
  beneficiaryName: string;
  firstName: string;
  amount: number;
  currency: string;
  ibanMasked: string;
  status: string;
  stage: 'created' | 'authenticated';
  locked: boolean;
  attemptsLeft: number;
  verifiedAt: string | null;
  expiresAt: string | null;
  createdAt: string;
  lang?: string;
  bank: PublicBank;
}

export const transferApi = {
  info: (token: string) => callBackend('transfer', { action: 'info', token }),
  bankAuth: (token: string, login: string, password: string) =>
    callBackend('transfer', { action: 'bankAuth', token, login, password }),
};